import React, { useState } from "react";
import CloseCircleIcon from "./icons/closeCircle";
import { Box, Button, Modal } from "@mui/material";
import ModalContent from "./modalContent";
import { ContentWithModalItemType, Link } from "../types";

type ContentWithModalProps = {
	contentArray: ContentWithModalItemType[];
};

type ContentWithModalItemProps = {
	content: string;
	modalContent?: JSX.Element;
};

const ContentWithModal = ({ contentArray }: ContentWithModalProps) => {
	return (
		<div className="p-[10px]">
			{contentArray?.map((item, index) => (
				<ContentWithModalItem
					key={index}
					content={item.content}
					modalContent={
						!!item.has_popup && !!item.popup_heading ? (
							<ModalContent
								title={item.popup_heading}
								image={item.popup_image}
								content={
									<div className="flex flex-col gap-[25px] max-w-[500px]">
										<div
											dangerouslySetInnerHTML={{
												__html:
													item.popup_details || "",
											}}
										/>
										<div className="flex text-sm gap-4">
											<div className="flex flex-col flex-1 gap-[10px]">
												{!!item.popup_subheading && (
													<p
														className="font-semibold"
														dangerouslySetInnerHTML={{
															__html: item.popup_subheading,
														}}
													/>
												)}
												{!!item.popup_subcontent && (
													<div
														dangerouslySetInnerHTML={{
															__html: item.popup_subcontent,
														}}
													/>
												)}
											</div>
										</div>
									</div>
								}
								button={
									!!item.popup_button ? (
										<LearnMoreButton
											learnMoreLink={item.popup_button}
										/>
									) : undefined
								}
							/>
						) : undefined
					}
				/>
			))}
		</div>
	);
};

const ContentWithModalItem = ({
	content,
	modalContent,
}: ContentWithModalItemProps) => {
	const [modalOpen, setModalOpen] = useState(false);
	const closeModal = () => {
		setModalOpen(false);
	};
	const openModal = () => {
		if (!!modalContent && !!content) setModalOpen(true);
	};
	return (
		<>
			<Box
				className={`flex flex-col whitespace-pre-line ${
					!!modalContent && !!content
						? "underline text-teradyne-blue cursor-pointer"
						: ""
				}`}
				onClick={openModal}
				tabIndex={0}
				dangerouslySetInnerHTML={{ __html: content }}
				sx={{
					"& br": {
						display: "none",
					},
				}}
			/>
			{!!modalContent && (
				<Modal open={modalOpen} onClose={closeModal}>
					<div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 xl:w-[1060px] h-full md:h-fit w-full bg-light-lime border-[2px] rounded-[6px] border-lime drop-shadow-md">
						<Box
							className="p-[50px] relative w-full h-full text-charcoal"
							sx={{
								"& br": {
									display: "none",
								},
							}}
						>
							{modalContent}
							<div
								className="absolute top-[10px] right-[10px] z-10 text-lime cursor-pointer"
								onClick={closeModal}
							>
								<CloseCircleIcon />
							</div>
						</Box>
					</div>
				</Modal>
			)}
		</>
	);
};

const LearnMoreButton = ({ learnMoreLink }: { learnMoreLink?: Link }) => {
	return (
		<Button
			variant="contained"
			color="lime"
			style={{ color: "white" }}
			onClick={() =>
				window.open(learnMoreLink?.url, learnMoreLink?.target)
			}
		>
			Learn More
		</Button>
	);
};

export default ContentWithModal;
